<div class="login-callback-container">
    <div class="callback-content">
        <div *ngIf="isProcessing" class="processing">
            <mat-spinner diameter="60"></mat-spinner>
            <h2>{{ 'Completing authentication...' }}</h2>
            <p>{{ 'Please wait while we verify your credentials.' }}</p>
        </div>

        <div *ngIf="!isProcessing && !errorMessage" class="success">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <h2>{{ 'Authentication Successful' }}</h2>
            <p>{{ 'Redirecting you back to login...' }}</p>
        </div>

        <div *ngIf="!isProcessing && errorMessage" class="error">
            <mat-icon class="error-icon">error</mat-icon>
            <h2>{{ 'Authentication Failed' }}</h2>
            <p class="error-message">{{ errorMessage }}</p>
            <button mat-raised-button color="primary" type="button" [disabled]="isLoggingOut" (click)="backToLogin()">
                {{ 'Back to Login' }}
            </button>
        </div>
    </div>
</div>
